/** Which developer snapshot a file holds (#303). */
export type SnapshotKind = 'snapshot' | 'clean';

const pad = (value: number): string => String(value).padStart(2, '0');

/** `sorrem-2026-10-28-143205-clean.png`: local time to the second, so a burst of captures sorts in order. */
export function buildSnapshotFileName(kind: SnapshotKind, at: Date): string {
    const date = `${at.getFullYear()}-${pad(at.getMonth() + 1)}-${pad(at.getDate())}`;
    const time = `${pad(at.getHours())}${pad(at.getMinutes())}${pad(at.getSeconds())}`;
    return `sorrem-${date}-${time}-${kind}.png`;
}
